<template lang="pug">
page(
    main-title="Интеграция",
    main-description="Информация и расширенные настройки",
    :links="[{component: 'EditShop', title: 'Информация о магазине'}, 'Интеграция']"
)
    .panel
        .panel-body
            template(v-if="!loaded") 
                span Секундочку...
            template(v-else)
                template(v-if="!data.initialization_status")
                    .row
                        .col-md-6.margin-bottom-10
                            | Если Вы уже установили 
                            a(:href="INSALES_APP_LINK", target="_blank") приложение Salesbeat, 
                            | то введите ссылку на Ваш магазин на поддомене <code>.myinsales.ru</code> 
                            | (например, <code>http://myshop-sv2.myinsales.ru</code>)
                        .col-md-4.col-xs-6
                            field(
                                label="Ссылка на магазина",
                                :item="insales_sub_domain",
                                @blur="validateInSalesSubDomain"
                            )
                        .col-md-2.col-xs-6
                            button.btn.btn-default(
                                @click="sendInSalesSubDomain", 
                                :class="sendInSalesSubDomainDisabledCls"
                            ) Ввёл, что дальше?

                template(v-else-if="data.initialization_status == 'not_started'")
                    .row
                        .col-md-12.margin-bottom-10 
                            | Приложение <b>Salesbeat</b> готово к установке в Ваш 
                            | <b>InSales</b> магазин – начнём?
                    .row
                        .col-md-12 
                            button.btn.btn-default(
                                @click="beginInstallation",
                                :class="beginInstallationDisabledCls"
                            ) Начинаем!

                template(v-else)
                    .row
                        .col-md-12
                            | Установка приложения <b>Salesbeat</b> 
                            | {{ data.initialization_status_display }}.
                            span(v-if="data.initialization_status == 'in_progress'")
                                |  Если Вы вернётесь на эту страницу чуть позже, то увидите результат.
                            span(v-else-if="data.initialization_status == 'had_error'")
                                |  Мы скоро свяжемся с Вами и поможем.  
                                | По такому поводу можете даже нам написать.

                    template(v-if="data.widget_in")
                        .row.margin-top-10
                            .col-md-12
                                span(v-if="data.widget_in.asset") 
                                    | Виджет для карточки товара установлен в файл <code>{{ data.widget_in.asset.name }}</code>. {{ data.widget_in.asset.comment }}.

                    .template(v-if="data.initialization_status == 'completed'")
                        field-with-save-button(
                            description="Дублировать <b>название службы доставки</b> в отдельное поле заказа InSales (может понадобиться, например, для RetailCRM)",
                            help="Если такого поля заказа ещё нет – мы создадим его",
                            name="field_name_for_delivery_service_name",
                            :data="data",
                            :initial="field_name_for_delivery_service_name_initial"
                        )
                        field-with-save-button(
                            description="Дублировать <b>адрес пункта самовывоза</b> в отдельное поле заказа InSales",
                            help="Если и такого поля ещё нет – тоже создадим",
                            name="field_name_for_pvz_info",
                            :data="data",
                            :initial="field_name_for_pvz_info_initial"
                        )
                        br
                        span Считаете, что тут мало возможностей? 
                            | Пишите скорее – добавим ещё что-нибудь. 
                            | Интегрироваться с <b>InSales</b> – одно удовольствие:)
                        //- .row
                            .col-md-7.margin-top-10
                                | Дублировать данные о выбранном способе доставки 
                                | в отдельное поле заказа InSales 
                                | (может понадобиться, например, для RetailCRM)
                                br
                                i.ti-help-alt.text-primary
                                |  Если такого поля заказа ещё нет – мы создадим его 
                            .col-md-2.col-xs-6.margin-top-10
                                field(
                                    label="Название поля",
                                    :item="field_name_for_pvz_info"
                                )
                            .col-md-3.col-xs-6.margin-top-10
                                button.btn.btn-default(
                                    @click="save('field_name_for_pvz_info')", 
                                    :class="fieldNameForPvz.saveCls"
                                ) {{ fieldNameForPvz.buttonText }}
                                button.btn.btn-o.btn-danger.margin-left-5(
                                    @click="save('field_name_for_pvz_info', true)", 
                                    :class="fieldNameForPvz.removeCls"
                                ) Больше не сохранять
                        //- .row
                            .col-md-7.margin-top-10
                                | Дублировать данные о пункте самовывоза в отдельное поле заказа InSales
                                br
                                i.ti-help-alt.text-primary
                                |  Если и такого поля ещё нет – тоже создадим
                            .col-md-2.col-xs-6.margin-top-10
                                field(
                                    label="Название поля",
                                    :item="field_name_for_pvz_info"
                                )
                            .col-md-3.col-xs-6.margin-top-10
                                button.btn.btn-default(
                                    @click="save('field_name_for_pvz_info')", 
                                    :class="fieldNameForPvz.saveCls"
                                ) {{ fieldNameForPvz.buttonText }}
                                button.btn.btn-o.btn-danger.margin-left-5(
                                    @click="save('field_name_for_pvz_info', true)", 
                                    :class="fieldNameForPvz.removeCls"
                                ) Больше не сохранять


</template>

<script>
import FieldWithSaveButton from './FieldWithSaveButton';

const INSALES_APP_LINK = 'https://www.insales.ru/collection/apps-agregatory-sluzhb-dostavok/product/salesbeat';

export default {
    name: 'InSalesIntegration',
    created() {
        this.getDataHook();
    },
    components: {
        FieldWithSaveButton
    },
    methods: {
        getDataHook() {
            this.$store.dispatch('getIntegrationDetails', {provider: 'insales'})
                .then(data => {
                    this.data = data;

                    // this.field_name_for_pvz_info.value = data.field_name_for_pvz_info
                    this.field_name_for_pvz_info_initial = data.field_name_for_pvz_info;
                    this.field_name_for_delivery_service_name_initial = data.field_name_for_delivery_service_name;

                    this.loaded = true;
                });
        },
        validateInSalesSubDomain() {
            if (!this.insales_sub_domain.value) {
                this.insales_sub_domain.valid = false;
                return;
            }

            if (!/^http[s]{0,1}:\/\//.test(this.insales_sub_domain.value)) {
                this.insales_sub_domain.value = 'http://' + this.insales_sub_domain.value;
            }

            let hostName = this.getHostName(this.insales_sub_domain.value);
            if (!/\.myinsales\.ru$/.test(hostName)) {
                this.insales_sub_domain.valid = false;
                this.insales_sub_domain.message = 'Ссылка должна быть на поддомене .myinsales.ru';
            }

            this.sendInSalesSubDomainDisabledCls.disabled = false;
        },
        sendInSalesSubDomain() {
            if (this.insales_sub_domain.valid && this.insales_sub_domain.value) {
                this.sendInSalesSubDomainDisabledCls.disabled = true;

                this.$store.dispatch('getIntegrationDetails', {
                    provider: 'insales',
                    insales_sub_domain: this.insales_sub_domain.value
                }).then(data => {
                    if (data.initialization_status) {
                        this.data = data;
                        this.insales_sub_domain.valid = true;
                        this.insales_sub_domain.message = null;
                    } else {
                        this.insales_sub_domain.valid = false;
                        this.insales_sub_domain.message = (
                            'Не получилось найти магазин, похоже, Вам стоит обратиться за помощью в чат ' +
                            'и мы поможем'
                        );
                    }
                });
            }
        },
        // save(field, isClean=false) {
        //     // Может быть мы просто чистим это поле:
        //     if (isClean) {
        //         this[field].value = null
        //     } else {
        //         // А может и нет
        //         if (!this[field].value || !this[field].value == this.data[field]) {
        //             this[field].valid = false
        //             return
        //         }
        //     }

        //     this.fieldNameForPvzDisabled = true
        //     this.$store.dispatch('saveInSalesIntegrationParams', {[field]: this[field].value})
        //         .then(_ => {
        //             this.data[field] = this[field].value
        //             this.fieldNameForPvzDisabled = false
        //         })
        // },
        beginInstallation() {
            this.beginInstallationDisabledCls.disabled = true;

            this.$store.dispatch('beginInstallation', {provider: 'InSales'})
                .then(data => {
                    this.data = data;
                });
        },
        /**
        *   A little hack to find hostname
        **/
        getHostName(link) {
            let $a = document.createElement('a');
            $a.href = link;

            return $a.hostname;
        }
    },
    // computed: {
    //     fieldNameForPvz() {
    //         const current = this.field_name_for_pvz_info && this.field_name_for_pvz_info.value,
    //             saved = this.data.field_name_for_pvz_info,
    //             disabled = this.fieldNameForPvzDisabled

    //         return {
    //             saveCls: {disabled: disabled || !current || current == saved,
    //                       hidden: current && current == saved},
    //             removeCls: {hidden: !current || current != saved},
    //             buttonText: (!current || current != saved) ? 'Сохранять в это поле' : 'Сохранено'
    //         }
    //     }
    // },
    data() {
        return {
            INSALES_APP_LINK,
            loaded: false,
            data: {
                initialization_status: null
            },

            insales_sub_domain: {
                value: null,
                valid: true
            },
            // field_name_for_pvz_info: {
            //     value: null,
            //     valid: true
            // },

            field_name_for_pvz_info_initial: null,
            field_name_for_delivery_service_name_initial: null,

            sendInSalesSubDomainDisabledCls: {
                disabled: false
            },
            beginInstallationDisabledCls: {
                disabled: false
            }
            // fieldNameForPvzDisabled: false
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/integration/InSalesIntegration.vue